import _toConsumableArray from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { isApolloErrorWithOneOfCodes } from './apolloUtils.js';
/** Converts list of values to list of SelectOptions */

var listToSelectOptions = function listToSelectOptions(values, getLabel, options) {
  var selectOptions = (options === null || options === void 0 ? void 0 : options.noEmptyValue) ? [] : [{
    value: ""
  }];
  values.forEach(function (value) {
    selectOptions.push({
      value: value,
      label: getLabel(value)
    });
  });
  return selectOptions;
};
/** Converts enum to list of select options */


var enumToSelectOptions = function enumToSelectOptions(enumObj, getLabel, options) {
  return listToSelectOptions(Object.values(enumObj), getLabel, options);
};
/** Finds correct label from given select options based on given value */


var findLabel = function findLabel(options, value) {
  var result = options.find(function (option) {
    return option.value === value;
  });
  return (result === null || result === void 0 ? void 0 : result.label) || "";
};
/** Removes empty placeholder option (Returns new array) */


var removeEmptyPlaceholderOption = function removeEmptyPlaceholderOption(options) {
  return options.filter(function (opt) {
    return opt.value !== "";
  });
};
/**
 * Removes options from `options` that match identifiers from `removeIdentifiers` Useful to remove
 * some options from Autocomplete options
 */


var removeOptions = function removeOptions(removeIdentifiers, options, optIdentifierKey) {
  if (!removeIdentifiers || removeIdentifiers.length === 0) return options;
  if (!options) return [];
  var selectedIdentifiersSet = new Set(removeIdentifiers);
  return options.filter(function (opt) {
    return !selectedIdentifiersSet.has(opt[optIdentifierKey]);
  });
};
/** Find selected options based on their identifiers. Useful to get initial options for Autocomplete */


var findSelectedOptions = function findSelectedOptions(selectedIdentifiers, options, optIdentifierKey) {
  if (!selectedIdentifiers || !options || selectedIdentifiers.length === 0) return [];
  var identifierToOptionMap = {};
  options.forEach(function (opt) {
    identifierToOptionMap[opt[optIdentifierKey]] = opt;
  });
  return selectedIdentifiers.map(function (identifier) {
    return identifierToOptionMap[identifier];
  });
};
/** Same as findSelectedOptions, but for a single object */


var findSelectedOption = function findSelectedOption(selectedIdentifier, options, optIdentifierKey) {
  return findSelectedOptions(selectedIdentifier && [selectedIdentifier], options, optIdentifierKey)[0];
};
/** Below are Formik utils */

/**
 * Gets initial values to pass to formik without extra fields
 *
 * @param emptyValues Values used by empty form
 * @param filledValues Values used by none-empty form. Extra fields (that don't appear in
 *   emptyValues) are removed.
 */


var getInitialValues = function getInitialValues(emptyValues, filledValues) {
  var initValues = emptyValues;

  if (filledValues) {
    Object.keys(emptyValues).forEach(function (key) {
      initValues[key] = filledValues[key];
    });
  }

  return initValues;
};
/**
 * Sets appropriate error for `fieldName` in Formik form if `mutationPromise` throws error that
 * matches one of graphql `errorCodes` provided.
 *
 * The promise is passed through (i.e. return promise succeeds if original promise succeeds, fails
 * if original promise fails)
 */


var displayFieldErrorOnMatchingError = function displayFieldErrorOnMatchingError(mutationPromise, formikHelpers, fieldName) {
  for (var _len = arguments.length, errorCodes = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    errorCodes[_key - 3] = arguments[_key];
  }

  return mutationPromise.catch(function (err) {
    var _a, _b, _c;

    if (errorCodes.length) {
      var codes = errorCodes;

      if (isCustomErrorMessageObjects(errorCodes)) {
        codes = errorCodes.map(function (item) {
          return item.errorCode;
        });
      }

      if (isApolloErrorWithOneOfCodes.apply(void 0, [err].concat(_toConsumableArray(codes)))) {
        var setSubmitting = formikHelpers.setSubmitting,
            setFieldError = formikHelpers.setFieldError;
        setSubmitting(false);
        var errorCode = (_b = (_a = err.graphQLErrors[0]) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.code;
        setFieldError(fieldName, isCustomErrorMessageObjects(errorCodes) ? (_c = errorCodes.find(function (item) {
          return item.errorCode === errorCode;
        })) === null || _c === void 0 ? void 0 : _c.customFieldErrorMessage : err.message);
      }
    }

    throw err;
  });
};
/**
 * Displays formik field error message if error has matching code/status with `errorsToFieldName`
 * Returns true if there was a match - error was displayed, false otherwise.
 */


var displayFieldError = function displayFieldError(err, formikHelpers, errorsToFieldName) {
  var _a, _b;

  var errorCodes = Object.keys(errorsToFieldName);
  if (!errorCodes.length) return false;

  if (isApolloErrorWithOneOfCodes.apply(void 0, [err].concat(errorCodes))) {
    var setSubmitting = formikHelpers.setSubmitting,
        setFieldError = formikHelpers.setFieldError;
    setSubmitting(false);
    var errorCode = (_b = (_a = err.graphQLErrors[0]) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.code;
    var fieldNameOrObj = errorsToFieldName[errorCode];
    var fieldName = fieldNameOrObj;
    var message = err.message;

    if (fieldNameOrObj && typeof fieldNameOrObj !== "string") {
      fieldName = fieldNameOrObj.fieldName;
      message = fieldNameOrObj.customErrorMessage;
    }

    setFieldError(fieldName, message);
    return true;
  }

  return false;
};

var isCustomErrorMessageObjects = function isCustomErrorMessageObjects(objs) {
  return !!objs.length && typeof objs[0] !== "string";
};

export { displayFieldError, displayFieldErrorOnMatchingError, enumToSelectOptions, findLabel, findSelectedOption, findSelectedOptions, getInitialValues, listToSelectOptions, removeEmptyPlaceholderOption, removeOptions };